import HeaderSubSection from "../../components/HeaderSubSection/index.vue";
import slideProfileSection from "../../components/slideProfileSection/index.vue";


export default {
  name: "profilePage",
  components: {
    HeaderSubSection,
    slideProfileSection
  },
};
